






























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Confirm from '@/components/Confirm.vue'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import { NoCache } from '@/decorators/NoCache'
import { EAutoPayItemStatus, EUserPermissions, ESchedulePaymentItemStatus, ISchedulePaymentItem, isDate } from '@zunta/configurations'

import Card from '@/components/Card.vue'
import Switcher from '@/components/Switcher.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { makeProcessingNotificationTimeout } from '@/utils/helpers'
import { ResidentModule } from '@/store/modules/resident.module'
import momentTz from 'moment-timezone'

@Component({
  components: {
    Card,
    Icon,
    DateInput,
    Confirm,
    Switcher,
    LoaderWrapper
  },
  props: {
    residentId: {
      type: Number,
      default: null
    },
    nextData: {
      type: String,
      default: null
    },
    isPrevAvailable: {
      type: Boolean,
      default: false
    },
    isNextAvailable: {
      type: Boolean,
      default: false
    },
    scheduleItemAmount: {
      type: Number,
      required: true
    }
  }
})
export default class ReviewActions extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  ESchedulePaymentItemStatus: any = ESchedulePaymentItemStatus
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User

  errors: any = {}
  confirm: string = ''
  postponeDate: Date | null = null
  processInProgress: boolean = false
  postponeSettingsOpened: boolean = false
  needsReviewLoading: boolean = false
  @NoCache
  get scheduleItemId () {
    return this.$route.params.scheduleItemId
  }

  get scheduleItems () {
    return this.$store.state.payments.autoPayItems
  }

  get hasEditPermission () {
    return this.user.hasPermissionFor(EUserPermissions.REVIEW_PAYMENTS)
  }

  @NoCache
  get selectedScheduleItem () {
    return this.scheduleItems.find((item: ISchedulePaymentItem) => {
      return item.id.toString() === this.scheduleItemId.toString()
    })
  }

  async toogleNeedsReview () {
    this.needsReviewLoading = true
    const response = await this.paymentsModuleInstance.autoPayNeedsReviewToggle(this.scheduleItemId)
    if (response.status === 'Failed') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: `Failed`,
        header: 'Failed',
        icon: 'warning'
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Success',
      header: 'Success',
      icon: 'warning'
    })
    await this.paymentsModuleInstance.fetchChainAutoPayItemsByFilters({
      statuses: [
        EAutoPayItemStatus.NEEDS_REVIEW,
        EAutoPayItemStatus.DECLINED,
        EAutoPayItemStatus.UPCOMING
      ]
    })
    this.needsReviewLoading = false
  }

  openPostponeSettings () {
    if (!this.hasEditPermission) {
      return
    }
    this.postponeSettingsOpened = true
  }

  async autoPayItemProcess () {
    if (!this.hasEditPermission) {
      return
    }

    this.processInProgress = true
    const timeout = makeProcessingNotificationTimeout(this, `Please don't refresh. Transaction is still processing.`, 3000)
    const scheduleItemId = this.scheduleItemId
    const response = await this.paymentsModuleInstance.autoPayItemProcess(scheduleItemId)
    clearTimeout(timeout)
    this.processInProgress = false
    if (!response.payment) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Make Payment',
        icon: 'warning'
      })
      return
    }

    if (response.status === 'Failed') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: `You may select another action or move to the next auto payment. ${response.message.join('\n') ? 'Reason: ' + response.message.join('\n') : ''}`,
        header: 'This payment was declined',
        icon: 'warning'
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Success',
      header: 'Success',
      icon: 'warning'
    })
    this.confirmScheduleItemAction('')
    this.$emit('solve', response)
  }

  async autoPayItemSkip () {
    if (!this.hasEditPermission) {
      return
    }
    const scheduleItemId = this.scheduleItemId
    const response = await this.paymentsModuleInstance.autoPayItemSkip(scheduleItemId)

    if (response.status && response.status === 'Failed') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Failed',
        icon: 'warning'
      })
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'was skipped',
      header: 'Autopay payment',
      icon: 'check'
    })

    this.confirmScheduleItemAction('')
    this.$emit('next')
  }

  async autoPayStop () {
    if (!this.hasEditPermission) {
      return
    }
    const scheduleItem = this.selectedScheduleItem
    const response = await this.paymentsModuleInstance.autoPayStop({
      autoPaySettingId: scheduleItem.setting.id,
      autoPayItemId: scheduleItem.id,
      stoppedFromReview: true
    })

    if (response.status && response.status === 'Failed') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Failed',
        icon: 'warning'
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'was stopped',
      header: 'Autopay payment',
      icon: 'check'
    })
    this.confirmScheduleItemAction('')
    this.$emit('next')
  }

  async scheduleItemPostpone () {
    if (!this.hasEditPermission) {
      return
    }
    const paymentType = this.selectedScheduleItem.paymentType
    this.errors = {}
    if (!isDate(this.postponeDate)) {
      this.errors.postponeDate = 'Required'
      return
    }
    const scheduleItemId = this.scheduleItemId
    const response = await this.paymentsModuleInstance.autoPayItemPostpone({
      autoPayItemId: scheduleItemId,
      date: momentTz.utc(this.postponeDate.toLocaleDateString('en-US')).toDate()
    })

    if (response.status && response.status === 'Failed') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Failed',
        icon: 'warning'
      })
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: `was postponed until ${this.postponeDate.toLocaleDateString('en-US')}`,
      header: paymentType === 'SCHEDULE' ? 'Payment schedule' : 'Autopay payment',
      icon: 'check'
    })
    this.postponeSettingsOpened = false
    this.postponeDate = null
    this.$emit('next')
  }

  confirmScheduleItemAction (value: string) {
    if (!this.hasEditPermission) {
      return
    }
    this.confirm = value
  }
}
